// components/startProject/StartFinalCTA.jsx
import { FiArrowRight } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import "./cta.css";

export default function StartFinalCTA() {
  return (
    <section className="sp-final-cta">
      <div className="sp-final-cta-inner">
        <span className="sp-final-badge">Let’s Work Together</span>

        <h2>
          Ready to Build Something <span>Exceptional?</span>
        </h2>

        <p>
          Talk directly with our project experts. Share your idea, get clarity,
          and move forward with confidence — no pressure, no obligation.
        </p>

        <div className="sp-final-actions">
          <a href="#start-project-form" className="sp-cta-primary">
            Start a Project <FiArrowRight />
          </a>

          <a
            href="https://wa.me/919532119007?text=Hi%20Oglitz%2C%20I%E2%80%99d%20like%20to%20discuss%20my%20project%20idea."
            target="_blank"
            rel="noopener noreferrer"
            className="sp-cta-secondary"
          >
            <FaWhatsapp /> WhatsApp Us
          </a>

          <a
            href="https://wa.me/+971568729406?text=Hi%20Oglitz%2C%20I%E2%80%99d%20like%20to%20discuss%20my%20project%20idea."
            target="_blank"
            rel="noreferrer"
            className="sp-cta-secondary"
          >
            <FaWhatsapp />
            WhatsApp Dubai
          </a>
        </div>

        <div className="sp-final-trust">
          ✓ NDA Protected &nbsp; • &nbsp; ✓ 100% Ownership &nbsp; • &nbsp; ✓
          Response within 4 hours
        </div>
      </div>
    </section>
  );
}
